module.exports = __webpack_public_path__ + "img/locator-img-red.275c806.svg";